export function isValidVariantKey(
  variantKey: string | null | undefined
): variantKey is string {
  return !!variantKey && variantKey.split("-")[0] !== "SONDER"
}
